import { Component, input } from '@angular/core'
import packageJson from '../../../../../package.json'
import { appName } from '../../../shared/data-access/constant/global.constant'

@Component({
  selector: 'lg-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent {
  protected readonly version = packageJson.version
  protected readonly appName = appName
  backendVersion = input<string>()
  protected readonly currentYear = (new Date()).getFullYear()
}
